import { Observable } from 'rxjs';

import {
	IAIAssistantResponse,
	IAIChatApi,
	IMessageHistory,
	Ratings,
} from '../private/ai-chat-api/ai-chat-api.interface';
import {
	AxiosInstanceType,
	SlAxiosInstanceService,
} from '../private/services/sl-axios-instance.service';
import { IApiUrls, IResponse } from '../private/global.interface';
import { AuthLevel, Authorize } from '../private/authorize.decorator';
import { SlApiContext } from '../private/api-context';
import { constructUrl } from '../private/utils/httpParamsUtils';
import { Service, Container } from '../../symphony';

@Service()
export class AIChatApi implements IAIChatApi {
	private environmentUrl: string;

	private axiosInstance: AxiosInstanceType;

	constructor() {
		this.environmentUrl = (
            Container.take('global', 'envUrl') as IApiUrls
		)?.aIChatHost;

		this.axiosInstance = Container.take(
			SlApiContext,
			SlAxiosInstanceService,
		).axios;
	}

    @Authorize(AuthLevel.public)
	public getAIAssistantResponse(
		messageHistory: IMessageHistory[],
		conversationId: string,
		systemPromptId: string,
		isTestUser = false,
	): Observable<IAIAssistantResponse> {
		return this.axiosInstance.post(
			constructUrl(this.environmentUrl, 'ai-adapter/api/solotutor/chat'),
			{
				messages: messageHistory,
				conversationId,
				systemPromptId: systemPromptId ? +systemPromptId : null,
				...(isTestUser && { isSLUser: isTestUser }),
			},
		);
	}

    @Authorize(AuthLevel.public)
    public rateMessage(
    	messageId: string,
    	rating: Ratings,
    ): Observable<IResponse> {
    	return this.axiosInstance.post(
    		constructUrl(this.environmentUrl, 'ai-adapter/api/message/rate'),
    		{
    			messageId,
    			rating,
    		},
    	);
    }
}

export * from '../private/ai-chat-api/ai-chat-api.interface';
